'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _dec2, _class, _class2, _temp;

// import ThanksPopup from '@quixeltools/quixel-ui-library/dist/components/megascans/popups/ThanksPopup'

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _reactRedux = require('react-redux');

var _components = require('components');

var _reduxForm = require('redux-form');

var _CancelSubscriptionPopup = require('@quixeltools/quixel-ui-library/dist/components/megascans/account/CancelSubscriptionPopup');

var _CancelSubscriptionPopup2 = _interopRequireDefault(_CancelSubscriptionPopup);

var _FeedbackPopup = require('@quixeltools/quixel-ui-library/dist/components/megascans/account/FeedbackPopup');

var _FeedbackPopup2 = _interopRequireDefault(_FeedbackPopup);

var _AppSideEffects = require('../AppSideEffects/AppSideEffects');

var _AppSideEffects2 = _interopRequireDefault(_AppSideEffects);

var _subscriptions = require('redux/modules/subscriptions');

var subscriptionService = _interopRequireWildcard(_subscriptions);

var _zendesk = require('redux/modules/zendesk.js');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FeedbackPopupContainer = (_dec = (0, _reduxForm.reduxForm)({
  form: 'cancelSubscriptionReason',
  fields: ['reason', 'otherInput']
}), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    subscription: state.user.subscription,
    user: state.user

  };
}, (0, _extends3.default)({}, subscriptionService, { createTicket: _zendesk.createTicket })), _dec(_class = _dec2(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(FeedbackPopupContainer, _React$Component);

  function FeedbackPopupContainer(props) {
    (0, _classCallCheck3.default)(this, FeedbackPopupContainer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FeedbackPopupContainer.__proto__ || (0, _getPrototypeOf2.default)(FeedbackPopupContainer)).call(this, props));

    _this.state = {
      successful: false,
      cancelling: false,
      message: '',
      error: ''
    };

    _this.isCancelling = _this.isCancelling.bind(_this);
    _this.onAborted = _this.onAborted.bind(_this);
    _this._cancelSubscription = _this._cancelSubscription.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(FeedbackPopupContainer, [{
    key: 'onAborted',
    value: function onAborted() {
      this.props.onCloseYes();
    }
  }, {
    key: '_cancelSubscription',
    value: function _cancelSubscription(value) {
      var _this2 = this;

      if (value.length > 0) {
        this.isCancelling(true);
        this.props.cancelSubscription(typeof value === 'string' ? value : 'Cancel anyway').then(function () {
          _this2.isCancelling(false);
          _this2.props.onCloseYes();
        }, function () {
          _this2.isCancelling(false);
          _this2.props.onCloseYes();
        });
      }
    }
  }, {
    key: 'isCancelling',
    value: function isCancelling(_isCancelling) {
      this.setState({
        cancelling: _isCancelling
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var expiresAt = this.props.subscription.expiresAt;

      var expiryDate = (0, _moment2.default)(expiresAt).format('MMMM Do, YYYY');

      return _react2.default.createElement(
        _AppSideEffects2.default,
        null,
        _react2.default.createElement(_FeedbackPopup2.default, {
          icon: "https://d3uwib8iif8w1p.cloudfront.net/megascans/home/quixel_2080_logo.png",
          cancelling: this.state.cancelling,
          cancelSubscriptionOnClick: this._cancelSubscription
        })
      );
    }
  }]);
  return FeedbackPopupContainer;
}(_react2.default.Component), _class2.contextTypes = {
  router: _react2.default.PropTypes.object,
  dialogs: _react2.default.PropTypes.object
}, _temp)) || _class) || _class);
exports.default = FeedbackPopupContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/FeedbackPopup/FeedbackPopup.jsx
// module id = 2835
// module chunks = 0